import React from 'react';
export function SolutionSection() {
  return <section className="w-full py-20 px-6" style={{
    backgroundColor: '#FAFAF8'
  }} data-id="element-231">
      <div className="max-w-3xl mx-auto text-center" data-id="element-232">
        {/* Eyebrow */}
        <span className="inline-block text-xs font-semibold tracking-widest uppercase mb-4" style={{
        color: '#FF5A5F',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-233">
          El Mecanismo Único
        </span>

        {/* Headline */}
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-6 leading-tight" style={{
        color: '#1A1A1A',
        fontFamily: 'Plus Jakarta Sans, sans-serif'
      }} data-id="element-234">
          El Sistema de Anticipación Psicológica
        </h2>

        {/* Body */}
        <p className="text-lg leading-relaxed mb-12" style={{
        color: '#6B7280',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-235">
          En lugar de responder dudas, inyectamos la información exacta en el
          cerebro del huésped{' '}
          <strong style={{
          color: '#1A1A1A'
        }} data-id="element-236">
            5 minutos antes de que el problema aparezca
          </strong>
          . Es una operación "Zero-Touch" donde todo fluye sin que tengas que
          intervenir manualmente.
        </p>

        {/* Visual comparison */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left" data-id="element-237">
          {/* Before */}
          <div className="rounded-2xl p-6 border-2 border-red-100 bg-red-50" data-id="element-238">
            <div className="flex items-center gap-2 mb-4" data-id="element-239">
              <span className="text-2xl" role="img" aria-label="Antes" data-id="element-240">
                😰
              </span>
              <span className="font-bold text-lg" style={{
              color: '#1A1A1A',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }} data-id="element-241">
                Antes: Modo Reacción
              </span>
            </div>
            <ul className="space-y-2" style={{
            color: '#6B7280',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-242">
              <li className="flex items-start gap-2" data-id="element-243">
                <span className="text-red-400 mt-0.5 flex-shrink-0" data-id="element-244">✗</span>
                Huésped tiene problema
              </li>
              <li className="flex items-start gap-2" data-id="element-245">
                <span className="text-red-400 mt-0.5 flex-shrink-0" data-id="element-246">✗</span>
                Te manda mensaje a las 3 AM
              </li>
              <li className="flex items-start gap-2" data-id="element-247">
                <span className="text-red-400 mt-0.5 flex-shrink-0" data-id="element-248">✗</span>
                Tú te despiertas y respondes
              </li>
              <li className="flex items-start gap-2" data-id="element-249">
                <span className="text-red-400 mt-0.5 flex-shrink-0" data-id="element-250">✗</span>
                Ansiedad constante
              </li>
            </ul>
          </div>

          {/* After */}
          <div className="rounded-2xl p-6 border-2 border-green-100 bg-green-50" data-id="element-251">
            <div className="flex items-center gap-2 mb-4" data-id="element-252">
              <span className="text-2xl" role="img" aria-label="Después" data-id="element-253">
                😌
              </span>
              <span className="font-bold text-lg" style={{
              color: '#1A1A1A',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }} data-id="element-254">
                Después: Zero-Touch
              </span>
            </div>
            <ul className="space-y-2" style={{
            color: '#6B7280',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-255">
              <li className="flex items-start gap-2" data-id="element-256">
                <span className="text-green-500 mt-0.5 flex-shrink-0" data-id="element-257">✓</span>
                Sistema anticipa la duda
              </li>
              <li className="flex items-start gap-2" data-id="element-258">
                <span className="text-green-500 mt-0.5 flex-shrink-0" data-id="element-259">✓</span>
                Mensaje automático llega a tiempo
              </li>
              <li className="flex items-start gap-2" data-id="element-260">
                <span className="text-green-500 mt-0.5 flex-shrink-0" data-id="element-261">✓</span>
                Tú duermes tranquilo
              </li>
              <li className="flex items-start gap-2" data-id="element-262">
                <span className="text-green-500 mt-0.5 flex-shrink-0" data-id="element-263">✓</span>
                Reseña de 5 estrellas garantizada
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}